// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarAssinaturaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /migration/assinaturas/migrar-todas.
 *
 * O fechamento da carga de assinaturas de UMA franquia: o run, a contabilidade
 * dos quatro desfechos por lista (`por_tipo`) e o desfecho de cada linha.
 *
 * `migradas + skipped + bloqueadas + falhas == total`, sempre.
 *
 * O `skipped` desta etapa merece leitura cuidadosa: alem do "ja migrado" das
 * irmas, ele inclui os webhooks que a leitura global trouxe e que NAO sao
 * desta franquia. Numero alto ali e o normal, nao sintoma.
 */
import type { Migration_AssinaturaResultadoRow } from './Migration_AssinaturaResultadoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_MigrarAssinaturaResponseDados {
run_id: number
total: number
migradas: number
skipped: number
bloqueadas: number
falhas: number
por_tipo: Record<string, Record<string, number>>
erros_zoho: string[]
resultados: Migration_AssinaturaResultadoRow[]
}

export type Migration_MigrarAssinaturaResponse = ApiResponse<Migration_MigrarAssinaturaResponseDados>;

registerResponseContract('Migration_MigrarAssinaturaResponse', {
  run_id:     { type: 'number',  required: true },
  total:      { type: 'number',  required: true },
  migradas:   { type: 'number',  required: true },
  skipped:    { type: 'number',  required: true },
  bloqueadas: { type: 'number',  required: true },
  falhas:     { type: 'number',  required: true },
  por_tipo:   { type: 'object',  required: true },
  erros_zoho: { type: 'array',   required: true },
  resultados: {
    type: 'array',
    required: true,
    items: {
      zoho_id:        { type: 'string',  required: false },
      nome:           { type: 'string',  required: false },
      tipo:           { type: 'string',  required: false },
      status:         { type: 'string',  required: false },
      run_id:         { type: 'number',  required: false },
      linha_local_id: { type: 'number',  required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
      erro:           { type: 'string',  required: false },
    },
  },
})
